// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__I_p_5","welcomeWrapper":"styles_welcomeWrapper__KpWwY","statusText":"styles_statusText__rSdKC"};